import { useNavigate } from '@remix-run/react';
import { AlertTriangle } from 'lucide-react'; // Using an icon for warning
import { useStorageStatus } from '~/hooks/useStorageStatus';

export function StorageManagementButton({
  setIsStorageExceededModalOpen,
}: {
  setIsStorageExceededModalOpen: (isOpen: boolean) => void;
}) {
  const navigate = useNavigate();
  const { showStorageWarning } = useStorageStatus();

  if (!showStorageWarning) {
    return null;
  }

  return (
    <button
      onClick={() => {
        setIsStorageExceededModalOpen(true);
      }}
      className="flex items-center justify-center w-[35px] h-[35px] cursor-pointer rounded-md bg-dualite-background-button text-yellow-400 hover:bg-dualite-background-button-hover transition-colors duration-150"
      title="Storage usage is high. Click to manage."
    >
      <AlertTriangle className="w-4 h-4" />
    </button>
  );
}
